import Link from 'gatsby-link';
import React from 'react';

import logo from '../../assets/svg/logo.svg';
import styles from '../../styles/header.module.styl';

// TODO set up redirect to mammography on server. At least until we'll build more decision aids

export default () => (
  <Link className={styles.logoLink} to="/mammography">
    <img className={styles.logo} src={logo} />
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/header/Logo.js